import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SoundSelectionDetail } from "./components/SoundSelectionDetail";
import { MenuCard } from "../../menu/MenuCard";
import { InputWithMargin } from "../../editor/Input";
import { MapElementReferenceModel } from "../../../../shared/action/MapElementReferenceModel";
import { MapElementSelectionDetail } from "./components/MapElementSelectionDetail";
import { MapElementFilter } from "../../../helper/MapElementFilter";
import { FloatInputField } from "../../shared/FloatInputField";
import { SoundCache, soundCache } from "../../../stores/SoundCache";
import { extendedMapMarkerValueModelTypesArray } from "../../../../shared/action/ValueModel";
import { SoundActionHelper } from "../../../canvas/game/controller/SoundActionHelper";
const Container = styled.div.withConfig({
  displayName: "PlaySoundActionDetails__Container",
  componentId: "sc-vl5eov-0"
})(["width:100%;"]);
const HeaderText = styled.div.withConfig({
  displayName: "PlaySoundActionDetails__HeaderText",
  componentId: "sc-vl5eov-1"
})(["cursor:pointer;margin-top:2px;margin-left:4px;"]);
const Row = styled.div.withConfig({
  displayName: "PlaySoundActionDetails__Row",
  componentId: "sc-vl5eov-2"
})(["display:flex;flex-direction:row;"]);
const Margin = styled.div.withConfig({
  displayName: "PlaySoundActionDetails__Margin",
  componentId: "sc-vl5eov-3"
})(["margin:4px;margin-left:8px;"]);
const CenteredRow = styled.div.withConfig({
  displayName: "PlaySoundActionDetails__CenteredRow",
  componentId: "sc-vl5eov-4"
})(["display:flex;flex-direction:row;align-items:center;"]);
const NumberInput = styled(FloatInputField).withConfig({
  displayName: "PlaySoundActionDetails__NumberInput",
  componentId: "sc-vl5eov-5"
})(["max-width:50px;margin-left:16px;"]);
export const PlaySoundActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  const [soundPaths] = useState(SoundCache.filterForPrefix(soundCache.getSoundPaths(), SoundCache.ALL_GAME_SOUND_PREFIX).filter(item => item != null));

  function onSoundPathSelected(path) {
    SoundActionHelper.applySoundPathSelection(action, path);
  }

  function onSoundTreeParameterSelected(treeParameter) {
    SoundActionHelper.applySoundTreeParameterSelection(action, treeParameter);
  }

  function onRangeChange(range) {
    action.setRangeInTiles(range);
  }

  function onClickTogglePosition() {
    if (action.sourcePosition) {
      action.setSourcePosition(null);
    } else {
      action.setSourcePosition(new MapElementReferenceModel({}));
    }
  }

  function onClickToggleLoop() {
    action.setLoopWhileInRange(!action.loopWhileInRange);
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(SoundSelectionDetail, {
    soundPaths: soundPaths,
    onSelectPath: onSoundPathSelected,
    onSelectTreeParameter: onSoundTreeParameterSelected,
    selectedPath: action.filePath,
    selectedTreeParameter: action.treeParameter,
    action: action,
    showEmptyStateAsInvalid: true
  })), /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(Row, {
    onClick: onClickTogglePosition
  }, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: action.sourcePosition != null,
    onChange: e => {}
  }), /*#__PURE__*/React.createElement(HeaderText, null, t("action_editor.node_play_sound_use_position"))), action.sourcePosition && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Margin, null, /*#__PURE__*/React.createElement(CenteredRow, null, t("action_editor.node_play_sound_position_description") + ":", /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: "",
    selectedElement: action.sourcePosition,
    elementSetter: action.setSourcePosition.bind(action),
    parameterTypes: extendedMapMarkerValueModelTypesArray,
    getSelectableElements: MapElementFilter.filterExtendedMapMarkerLabels
  }))), /*#__PURE__*/React.createElement(Margin, null, /*#__PURE__*/React.createElement(CenteredRow, null, t("action_editor.node_play_sound_position_range") + ":", /*#__PURE__*/React.createElement(NumberInput, {
    value: action.rangeInTiles,
    onlyPositive: true,
    onChange: onRangeChange
  }))), /*#__PURE__*/React.createElement(Margin, null, /*#__PURE__*/React.createElement(CenteredRow, {
    onClick: onClickToggleLoop
  }, t("action_editor.node_play_sound_loop") + ":", /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: action.loopWhileInRange,
    onChange: e => {}
  }))))));
});